var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footBox"},[_c('div',{staticClass:"footBox2"},[_c('img',{staticClass:"footBox_icon",attrs:{"src":require("@/images/footBox_icon.png")}}),_c('div',{staticClass:"footBox_name"},[_vm._v(" 技术支持单位："),_c('img',{attrs:{"src":require("@/images/footBox_name.png")}}),_vm._v("山东中飞科技有限公司 ")])])])
}]

export { render, staticRenderFns }